import React, { useState, useEffect } from 'react';
import { Text } from 'react-native';

const PercentageLoader = ({
    color = '#4DA6FF',
    fontSize = 14,
    fontWeight = '600',
    style
}) => {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setPercent(prev => {
                if (prev >= 99) return 99;
                const remaining = 100 - prev;
                const increment = Math.max(0.1, remaining * 0.05);
                return prev + increment;
            });
        }, 50);
        return () => clearInterval(interval);
    }, []);

    return (
        <Text style={[{ color, fontSize, fontWeight }, style]}>
            {Math.floor(percent)}%
        </Text>
    );
};

export default PercentageLoader;
